import PropTypes from 'prop-types';
import styles from './FJPhotoRemoveBgAutoLeft.module.less';
import classNames from 'classnames';
import FJImageInputTwo from '../../../../common/components/FJImageInput/FJImageInputTwo';
import { UPLOAD_FILE_TYPE_IMAGE_EXTENDER } from '../../../../config/dataConfig/FJGenerateData';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJPhotoSettingBoxContainer from '../container/FJPhotoSettingBoxContainer';
import FJBrushCardThreeContainer from '../../../../common/components/FJBrushCard/FJBrushCardThreeContainer';
import FJLocalStore from '../../../../store/FJLocalStore';

const FJPhotoRemoveBgAutoLeft = props => {
    const {
        isShow,
        uploadAutoBgImage,
        isNotImage,
        isPhotoRemoveBg,
        freeNumCreation,
        isFree,
        useCredit,
        displayUploadFile,
        openMediaLibrary,
    } = props;

    return (


                <div className={classNames(styles.auto_left, { [styles.show]: isShow })}>
                    {isShow && (<FJImageInputTwo
                        uploadImg={uploadAutoBgImage}
                        openMediaLibrary={openMediaLibrary}
                        isSmallComponent={!isNotImage}
                        acceptFile={UPLOAD_FILE_TYPE_IMAGE_EXTENDER}
                        multiple={true}
                        isShowTips={true}
                        btnText={'choose-image'}
                        isIconRight={true}
                        disabled={displayUploadFile}
                        text={'click-or-drag-to-upload-image'}
                        btnClassName={styles.btn}
                        isJudgeLogin={true}
                        icon={
                            <>
                                {isFree && (
                                    <div className={styles.free_tries}>
                                        {freeNumCreation === 1
                                            ? FJLocalStore._('free-trie-left')
                                            : FJLocalStore._('free-tries-left').replace('xxx', freeNumCreation)}
                                    </div>
                                )}
                                {!isFree && (
                                    <div className={styles.use_credit}>
                                        {FJLocalStore._('use-credit').replace('xxx', useCredit)}
                                    </div>
                                )}
                            </>
                        }
                        smallIcon={
                            <>
                                {isFree && (
                                    <div className={styles.small_free_tries}>
                                        {freeNumCreation === 1
                                            ? FJLocalStore._('free-trie-left')
                                            : FJLocalStore._('free-tries-left').replace('xxx', freeNumCreation)}
                                    </div>
                                )}
                                {!isFree && (
                                    <div className={styles.small_use_credit}>
                                        {FJLocalStore._('use-credit').replace('xxx', useCredit)}
                                    </div>
                                )}
                            </>
                        }
                        smallText={'upload-up-to-20-images'}
                    />
                        )}
                    <FJVerticalScroller className={classNames(styles.scroller, { [styles.mt_0]: isPhotoRemoveBg })}>
                        {!isNotImage && <FJBrushCardThreeContainer />}
                        {!isNotImage && <FJPhotoSettingBoxContainer isShow={true} />}
                    </FJVerticalScroller>
                </div>
    );
};

FJPhotoRemoveBgAutoLeft.propTypes = {
    isShow: PropTypes.bool,
    uploadAutoBgImage: PropTypes.func,
    isNotImage: PropTypes.bool,
    isPhotoRemoveBg: PropTypes.bool,
    freeNumCreation: PropTypes.number,
    isFree: PropTypes.bool,
    useCredit: PropTypes.number,
    displayUploadFile: PropTypes.bool,
    openMediaLibrary: PropTypes.func,
};

export default FJPhotoRemoveBgAutoLeft;
